import { render, staticRenderFns } from "./TitleAndTimeline.vue?vue&type=template&id=36c90508&scoped=true&"
import script from "./TitleAndTimeline.vue?vue&type=script&lang=js&"
export * from "./TitleAndTimeline.vue?vue&type=script&lang=js&"
import style0 from "./TitleAndTimeline.vue?vue&type=style&index=0&id=36c90508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c90508",
  null
  
)

export default component.exports